import { Grid } from '@mui/material'
import { Card, Box, ListItem, CardHeader } from 'components'
import { get } from 'lodash'
import { formatCurrency, formatDate, zipCodeMask } from 'utils'
import { Order } from 'modules/orders/types'
import { addHours } from 'date-fns'

export const Freight = ({ order }: { order?: Order }) => {
  const firstColumn: any = [
    {
      label: 'Tipo de Frete',
      key: 'freightType.name'
    },
    {
      label: 'Previsão de Entrega',
      key: 'deliveryDate',
      transform: (value: string) =>
        `${formatDate(addHours(new Date(value), 3))}`
    },
    {
      label: 'Data Desejada',
      key: 'requestedDate',
      transform: (value: string) => (value ? formatDate(value) : '-')
    }
  ]

  const secondColumn = [
    {
      label: 'Transportadora',
      key: 'carrier.name'
    },
    {
      label: 'Valor Frete',
      key: 'freightPrice',
      transform: (value: number) => formatCurrency(value)
    }
  ]

  const thirdColumn = [
    {
      label: 'Distância estrada de chão',
      key: 'dirtRoadQuiz.quest1',
      transform: (value: string) => (value || '0') + 'km'
    },
    {
      label: 'Entra carreta no local e a mesma consegue fazer o retorno?',
      key: 'dirtRoadQuiz.quest2',
      transform: (value: boolean) => (value ? 'Sim' : 'Não')
    },
    {
      label: 'Em caso de chuva, o caminhão consegue chegar até o local?',
      key: 'dirtRoadQuiz.quest3',
      transform: (value: boolean) => (value ? 'Sim' : 'Não')
    },
    {
      label: 'Já anexou a localização da entrega?',
      key: 'dirtRoadQuiz.quest4',
      transform: (value: boolean) => (value ? 'Sim' : 'Não')
    }
  ]

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Card
          sx={{
            visibility: { xs: 'hidden', sm: 'visible', md: 'visible' },
            padding: { xs: 0, sm: 0, md: 0 },
            maxWidth: 800
          }}
        >
          <Box
            sx={{ visibility: { xs: 'visible', sm: 'visible', md: 'visible' } }}
          >
            <Box
              sx={{
                padding: {
                  xs: 0,
                  sm: '0 24px 0 0',
                  md: '0px 24px 0 0px'
                },
                borderBottom: { xs: 'none', sm: '1px solid #E0E0E0' }
              }}
            >
              <CardHeader title="Frete" />
            </Box>
            {/* <Divider
            sx={{ visibility: { xs: 'hidden', sm: 'visible', md: 'visible' } }}
          /> */}
            <Grid container spacing={3} style={{ padding: 24 }}>
              <Grid item xs={12} sm={4}>
                {firstColumn?.map((item: any) => (
                  <ListItem
                    key={item.key}
                    label={item.label}
                    value={get(order, item.key)}
                    transform={item?.transform}
                  />
                ))}
              </Grid>
              <Grid item xs={12} sm={4}>
                {secondColumn?.map((item: any) => (
                  <ListItem
                    key={item.key}
                    label={item.label}
                    value={get(order, item.key)}
                    transform={item?.transform}
                  />
                ))}
              </Grid>
              <Grid item xs={12} sm={4}>
                {thirdColumn?.map((item: any) => (
                  <ListItem
                    key={item.key}
                    label={item.label}
                    value={get(order, item.key)}
                    transform={item?.transform}
                  />
                ))}
              </Grid>
            </Grid>
          </Box>
        </Card>
      </Grid>
      <Grid item xs={6}>
        <Card
          sx={{
            visibility: { xs: 'hidden', sm: 'visible', md: 'visible' },
            padding: { xs: 0, sm: 0, md: 0 },
            maxWidth: 800
          }}
        >
          <Box
            sx={{ visibility: { xs: 'visible', sm: 'visible', md: 'visible' } }}
          >
            <Box
              sx={{
                padding: {
                  xs: 0,
                  sm: '0 24px 0 0',
                  md: '0px 24px 0 0px'
                },
                borderBottom: { xs: 'none', sm: '1px solid #E0E0E0' }
              }}
            >
              <CardHeader title="Dados de Entrega" />
            </Box>
            {/* <Divider
            sx={{ visibility: { xs: 'hidden', sm: 'visible', md: 'visible' } }}
          /> */}
            <Grid container spacing={3} style={{ padding: 24 }}>
              <Grid item xs={12}>
                <ListItem
                  label={`Cliente${
                    order?.orderType?.id === 'V' ? ' Remessa' : ''
                  }`}
                  value={`${order?.deliveryAddress?.id || ''} - ${
                    order?.deliveryAddress?.name || ''
                  }`}
                />

                <ListItem
                  label={`Telefone`}
                  value={`${order?.deliveryAddress?.phone || ''}`}
                />

                <ListItem
                  label={`Logradouro`}
                  value={`${order?.deliveryAddress?.address || ''}
                    ${
                      order?.deliveryAddress?.number
                        ? ',' + order?.deliveryAddress?.number
                        : ''
                    }
                    ${
                      order?.deliveryAddress?.complement
                        ? ',' + order?.deliveryAddress?.complement
                        : ''
                    }`}
                />

                <ListItem
                  label={`Bairro`}
                  value={`${order?.deliveryAddress?.district || ''}`}
                />

                <ListItem
                  label={`Cidade`}
                  value={`${order?.deliveryAddress?.city || ''} - ${
                    order?.deliveryAddress?.uf || ''
                  }`}
                />

                <ListItem
                  label={`Cep`}
                  value={`${
                    order?.deliveryAddress?.cep
                      ? zipCodeMask(String(order?.deliveryAddress?.cep))
                      : ''
                  }`}
                />

                <ListItem
                  label={`Observação de entrega`}
                  value={`${order?.expeditionObs}`}
                />
              </Grid>
            </Grid>
          </Box>
        </Card>
      </Grid>
    </Grid>
  )
}
